<template>
  <v-container class="pa-0">
    <h3 class="pb-3">Add a File</h3>
    <hr class="thick" />
    <div class="mb-4 mt-3">
      <v-form ref="newFolderForm" v-model="form.valid">
        <p>
          <strong>Upload one or more files:</strong>
          <br v-if="maxFileSize != ''" />
          <small v-if="maxFileSize != ''">Maximum file size: {{ maxFileSize }}</small>
          <amaze-upload
            dropzone-id="file-manager-upload"
            @dropzone-add-files="addFiles"
            @dropzone-remove-file="removeFile"
            class="mb-3"
          ></amaze-upload>
        </p>

        <div v-if="error">
          <span class="msg error">{{ error }}</span>
        </div>
        <div class="mt-4">
          <v-btn
            class="ml-0"
            v-bind:disabled="!countFiles || loading"
            v-on:click="uploadFiles"
            :loading="loading"
            color="primary"
            >Upload File(s)</v-btn
          >
          <v-btn v-on:click="hideModal">Cancel and Close</v-btn>
        </div>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import modal from './../mixins/modal';
import translate from './../../../mixins/translate';
import helper from './../../../mixins/helper';
import manager from './../../manager/mixins/manager.js';

export default {
  name: 'Upload',
  mixins: [modal, translate, helper, manager],
  data() {
    return {
      loading: false,

      manager: 'left',

      // selected files
      newFiles: [],

      // overwrite if exists
      overwrite: 0,

      error: null,

      form: {
        valid: false,
        newFiles: [
          v =>
            !!v || 'There appears to be no file attached. Please try again.',
        ],
      },
    };
  },
  computed: {
    /**
     * Progress bar value - %
     * @returns {number}
     */
    progressBar() {
      return this.$store.state.fm.messages.actionProgress;
    },

    /**
     * Count of files selected for upload
     * @returns {number}
     */
    countFiles() {
      return this.newFiles.length;
    },

    /**
     * Calculate the size of all files
     * @returns {*|string}
     */
    allFilesSize() {
      let size = 0;

      for (let i = 0; i < this.newFiles.length; i += 1) {
        size += this.newFiles[i].size;
      }

      return this.bytesToHuman(size);
    },
    maxFileSize() {
      return process.env.VUE_APP_API_MAX_UPLOAD_SIZE
        ? process.env.VUE_APP_API_MAX_UPLOAD_SIZE
        : '';
    },
  },
  methods: {
    addFiles(files) {
      for (const file of files.files) {
        this.newFiles.push(file);
      }
    },
    removeFile(file) {
      const idx = this.newFiles.indexOf(file);
      if (idx > -1) {
        this.newFiles.splice(idx, 1);
      }
    },
    /**
     * Select file or files
     * @param event
     */
    selectFiles(event) {
      // files selected?
      if (event.target.files.length === 0) {
        // no file selected
        this.newFiles = [];
      } else {
        // we have file or files
        this.newFiles = event.target.files;
      }
    },

    /**
     * Upload new files
     */
    uploadFiles() {
      // if files exists
      if (this.countFiles) {
        this.loading = true;
        // upload files
        this.$store
          .dispatch('fm/upload', {
            files: this.newFiles,
            overwrite: this.overwrite,
          })
          .then((response) => {
            this.loading = false;
            // if upload is successful
            if (response.data.result.status === 'success') {
              // close modal window
              this.hideModal();
            } else {
              this.error = response.data.result.message;
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.fm-modal-upload {
  .fm-btn-wrapper {
    position: relative;
    overflow: hidden;
    padding-bottom: 6px;
    margin-bottom: 0.6rem;
  }

  .fm-btn-wrapper input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }

  .fm-upload-list .far {
    padding-right: 0.5rem;
  }

  .fm-upload-list .form-check-inline {
    margin-right: 0;
  }

  .fm-upload-info > .progress {
    margin-bottom: 1rem;
  }
}
</style>
